export default "__VITE_ASSET__DkPPcjmv__"